// ============================================
// PAGE - DTE (Documentos Tributarios Electrónicos)
// ============================================

import { useState } from 'react';
import { cn } from '@almacenes/ui';
import { MdVerifiedUser, MdReceipt } from 'react-icons/md';
import { CertificadoView, FoliosView } from './components';

type TabType = 'certificado' | 'folios';

export const DtePage = () => {
  const [tabActivo, setTabActivo] = useState<TabType>('certificado');

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white shadow-sm border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <h1 className="text-3xl font-bold text-gray-900">
            Documentos Tributarios Electrónicos
          </h1>
          <p className="mt-2 text-sm text-gray-600">
            Gestiona tu certificado digital y folios del SII
          </p>
        </div>
      </div>

      {/* Tabs */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-6">
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
          {/* Tab Headers */}
          <div className="border-b border-gray-200 bg-gray-50">
            <nav className="flex -mb-px">
              <button
                onClick={() => setTabActivo('certificado')}
                className={cn(
                  'flex-1 py-4 px-6 text-center font-semibold text-sm transition-all border-b-2 flex items-center justify-center gap-2',
                  tabActivo === 'certificado'
                    ? 'border-blue-500 text-blue-600 bg-white'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                )}
              >
                <MdVerifiedUser className="text-xl" />
                Certificado Digital
              </button>
              <button
                onClick={() => setTabActivo('folios')}
                className={cn(
                  'flex-1 py-4 px-6 text-center font-semibold text-sm transition-all border-b-2 flex items-center justify-center gap-2',
                  tabActivo === 'folios'
                    ? 'border-blue-500 text-blue-600 bg-white'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                )}
              >
                <MdReceipt className="text-xl" />
                Folios Activos
              </button>
            </nav>
          </div>

          {/* Tab Content */}
          <div className="p-6">
            {tabActivo === 'certificado' && <CertificadoView />}
            {tabActivo === 'folios' && <FoliosView />}
          </div>
        </div>
      </div>
    </div>
  );
};
